import Vue from 'vue';
import { mapGetters, mapActions, mapMutations } from 'vuex';
import { Component, Prop, Watch } from 'vue-property-decorator';
import ReadBottom from '@mail/components/Read/ReadBottom.vue'
import ReadSender from '@mail/components/Read/ReadSender.vue'
import ReadAttachment from '@mail/components/Read/ReadAttachment.vue'
import ReadTitle from '@mail/components/Read/ReadTitle.vue'
import ReadBody from '@mail/components/Read/ReadBody.vue'
import * as types from '@mail/store/types'

@Component({
    components: {
        ReadBottom,
        ReadSender,
        ReadAttachment,
        ReadTitle,
        ReadBody,
    },
    computed: mapGetters({
        currentEmail: types.EMAIL_CURRENT,
        // pagedList: mailtypes.EMAIL_LIST,
    }),
    methods: {
        ...mapActions({
            loadDetail: types.EMAIL_DETAIL,
        }),
    },
})
export default class ReadContainer extends Vue {
    //
    // ──────────────────────────────────────────────── I ──────────
    //   :::::: D A T A : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────
    //

    modalStatus: boolean = true;
    moveModalStatus: boolean = true;

    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: A C T I O N S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //
    // load!: () => Promise<any>;
        loadDetail!: (id: string) => Promise<any>;
    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: G E T T E R S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //
    currentEmail!: mail.EmailMessage;
    // pagedList!: () => Promise<PagedItemList<mail.EmailMessage>>;

    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: M E T H O D S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //

    changeModal(show: boolean) {
        this.modalStatus = show;
    }

    changeMoveModal(show: boolean) {
        this.moveModalStatus = show;
    }
    containerClick(e: Event) {
        var modal = document.getElementById('openModal');
        if (e.target == modal) {
            if (modal) {
                this.modalStatus = false;
            }
        }
        var moveModal = document.getElementById('openMoveModal');
        if (e.target == moveModal) {
            if (moveModal) {
                this.moveModalStatus = false;
            }
        }
    }

    //
    // ────────────────────────────────────────────────────────── I ──────────
    //   :::::: L I F E C Y C L E : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────────
    //

    created() {
        const id = this.$route.query.id as string;
        this.loadDetail(id).then((r: any) => {
            if (r) {
                let item = {
                    id: r.id,
                    method: 'none',
                    email: r,
                };
                //this.load();
                // this.clearSelections();
            }
        }).catch(async (err) => {
            if (err.type == 'ErrorItemNotFound') {
                await (window as any).alertAsync(this.$t('M_Mail_ErrorItemNotFound').toString());                
                history.back();                
            }
        });;
    }
}
